/**
 * Created By: Tyrus Malmstrom
 * Creation Date: 05/23/2022
 * Description:
 *   - Mixin to house specific functionality and logic to register offline events for our appliction.
 */

//  [ ] TODO CLEAN: Shouldn't have to do this -- needed in order to pass Designer linting rules.
/* eslint-disable */

export default {
  data() {
    return {
      isOffline: false,
    };
  },
  methods: {
    enableOfflineEventListeners() {
      if (!_.isObject(this.offlineEventListeners)) return;
      for (const key of Object.keys(this.offlineEventListeners)) {
        window.Offline.on(key, this.offlineEventListeners[key]);
      }
    },
    disableOfflineEventListeners() {
      if (!_.isObject(this.offlineEventListeners)) return;
      for (const key of Object.keys(this.offlineEventListeners)) {
        window.Offline.off(key, this.offlineEventListeners[key]);
      }
    },
    initializeOfflineJs() {
      if (!window.Offline) {
        const offlineInterval = setInterval(() => {
          if (window.Offline) {
            clearInterval(offlineInterval);
            this.enableOfflineEventListeners();
          }
        }, 1000);
      } else {
        this.enableOfflineEventListeners();
      }
    },
  },
  mounted() {
    this.initializeOfflineJs();
  },
  beforeDestroy() {
    this.disableOfflineEventListeners();
  },
};
